/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import { featureEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import SiteBannerController from 'components/global/site-banners/site-banner-controller';
EezyStimulusApplication.register('site-banner', SiteBannerController);

import TeamsNagController from 'components/global/teams-nag/teams-nag-controller';
EezyStimulusApplication.register('teams-nag', TeamsNagController);

import LanguageSwitcherController from 'components/util/language-switcher/language-switcher-controller';
EezyStimulusApplication.register('language-switcher', LanguageSwitcherController);

import FlashMessageController from 'components/util/alerts/flash/flash-message-controller';
EezyStimulusApplication.register('flash-message', FlashMessageController);

import ReactivationBannerController from 'components/global/site-banners/reactivation-banner/reactivation-banner-controller';

import UpgradeBannerController from 'components/global/site-banners/upgrade-banner/upgrade-banner-controller';

if (featureEnabled('one_click_purchases')) {
  import(/* webpackChunkName: "rebuys-styles", webpackPrefetch: true */ 'components/rebuys/rebuys');

  import(/* webpackChunkName: "purchase-modal-styles", webpackPrefetch: true */ 'components/util/purchase-modal/purchase-modal');

  EezyStimulusApplication.register('reactivation-banner', ReactivationBannerController);

  import(
    /* webpackChunkName: "reactivation-modal-controller" */
    /* webpackPrefetch: true */
    'components/reactivations/reactivation-modal/reactivation-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('reactivation-modal', controller.default);
  });

  import(
    /* webpackChunkName: "rebuy-credits-modal-controller" */
    /* webpackPrefetch: true */
    'components/rebuys/rebuy-credits-modal/rebuy-credits-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('rebuy-credits-modal', controller.default);
  });

  import(
    /* webpackChunkName: "confirm-payment-modal-controller" */
    /* webpackPrefetch: true */
    'components/rebuys/confirm-payment-modal/confirm-payment-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('confirm-payment-modal', controller.default);
  });

  EezyStimulusApplication.register('upgrade-banner', UpgradeBannerController);

  import(
    /* webpackChunkName: "upgrade-modal-controller" */
    /* webpackPrefetch: true */
    'components/upgrades/upgrade-modal/upgrade-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('upgrade-modal', controller.default);
  });

  import(
    /* webpackChunkName: "free-trial-upgrade-modal-controller" */
    /* webpackPrefetch: true */
    'components/free-trial-upgrades/free-trial-upgrade-modal/free-trial-upgrade-modal-controller'
  ).then((controller) => {
    EezyStimulusApplication.register('free-trial-upgrade-modal', controller.default);
  });
}
